module.exports = __webpack_public_path__ + "static/media/arraySortingAlgorithms.9001324c.png";